import { OrganizationAuthMethodEnum } from 'src/api/main'
import { paths } from 'src/router'

import { SocialConnectCallbackPage } from './SocialConnectCallbackPage'

export const EntraIdOrgConnectCallback = () => (
  <SocialConnectCallbackPage
    provider={OrganizationAuthMethodEnum.ENTRAID}
    flow="orgConnect"
    redirectPath={paths.auth.entraIdOrgConnectCallback}
    successMessageKey="profileAuthMethods.connectSuccessEntraid"
  />
)
